import { render } from "./SegregationPlanFilter.vue?vue&type=template&id=38e9297a&ts=true"
import script from "./SegregationPlanFilter.vue?vue&type=script&lang=ts"
export * from "./SegregationPlanFilter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__